<template>
  <div class="layout">
    <div v-if="isSubApp" style="overflow: auto;" class="sub-content">
      <router-view></router-view>
    </div>
    <zczy-frame
      v-else
      :menus="menus"
      is-popup
      :logo-click="onClickLogo"
      :header-menu-click="onHeaderMenuClick"
      :menu-click="onMenuClick"
      :active-header-id="activeHeaderId"
      :active-id="activeId"
      :badge-data="badgeData"
      badge-key="name"
      :user-name="memberName"
      :avatar="headUrl"
      :collects="collects"
      :collect-tooltip="collectTooltip"
      :show-account="false"
      :has-sidebar="hasSidebar"
      @onCollect="onCollectClick"
    >
      <!-- TODO: 定制头部如何处理 platformHeader.vue -->
      <template #logo>
        <div class="layout__logo">
          <img v-if="channel === 'yinlun'" src="@/assets/images/logo_yinlun.png" />
          <img v-else-if="channel === 'zhongqi'" src="@/assets/images/logo_zhongqi.png" />
          <svg-icon v-else icon-class="logo_white" class-name="layout__logo-icon"></svg-icon>
          <span class="layout__logo-tag">货主</span>
        </div>
      </template>
      <template #menuIcon="{ menu }">
        <svg-icon :icon-class="menu.icon"></svg-icon>
      </template>
      <template #right>
        <div class="layout__header-operate">
          <el-button-select v-if="isSpecificUrlPrefix()" v-model="currentVersion" :options="options" />
          <el-tooltip
            v-if="!['forun_zhiyun', 'zaozhuang_zhiyun', 'maotong_zhiyun', 'canggang_zhiyun'].includes(COOPERATION_NAME)"
            content="客服热线：400-088-5566"
            effect="light"
            popper-class="popper_white"
          >
            <div class="layout__header-operate-item layout__header-operate-phone">
              <svg-icon icon-class="phone"></svg-icon>
              <span>客服</span>
            </div>
          </el-tooltip>
          <a class="layout__header-operate-item layout__header-operate-desktop" href="/">
            <svg-icon icon-class="desktop"></svg-icon>
            <span>返回官网</span>
          </a>
          <div v-if="!['yinlun', 'zhongqi'].includes(channel) && !COOPERATION_NAME" class="layout__header-operate-item">
            <el-dropdown @command="onChooseRole">
              <span>其他角色登录<i class="el-icon-arrow-down"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="header-link-item" command="ship">
                  <svg-icon icon-class="role-cy" class="icon-item" alt="" />
                  <span class="role-dp-item">船运版</span>
                </el-dropdown-item>
                <el-dropdown-item class="header-link-item" command="link">
                  <svg-icon icon-class="role-dsly" class="icon-item" alt="" />
                  <span class="role-dp-item">多式联运版</span>
                </el-dropdown-item>
                <el-dropdown-item class="header-link-item" command="jms">
                  <svg-icon icon-class="role-jms" class="icon-item" alt="" />
                  <span class="role-dp-item">加盟商版</span>
                </el-dropdown-item>
                <el-dropdown-item class="header-link-item" command="extra">
                  <svg-icon icon-class="role-jmyl" class="icon-item" alt="" />
                  <span class="role-dp-item">加盟运力版</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="layout__header-account">
          <img class="layout__header-account-ico" :src="headUrl || defaultAvatar" alt="" @click="onNavToUserInfo" />
          <p class="layout__header-account-text">
            <span class="layout__header-account-name">{{ memberName }}</span>
            <a @click="loginOut">[退出]</a>
            <svg-icon v-if="+account.nooType === 1" icon-class="account-main" class="layout__header-account-tag"></svg-icon>
            <svg-icon v-else icon-class="account-sub" class="layout__header-account-tag"></svg-icon>
          </p>
          <div class="layout__header-account-popup">
            <i class="layout__header-account-popup-arr"></i>
            <div class="layout__header-account-popup-header">
              <div class="layout__header-account-popup-header-info">
                <i :class="[`icon-account-${account.nooType}`]"></i>
                <span class="layout__header-account-popup-header-info-title">当前账号</span>
              </div>
            </div>
            <div v-if="+account.nooType === 0" class="layout__header-account-popup-block">
              <p class="block-title">主账号信息</p>
              <p class="block-name">{{ account.mainBackup4 }}</p>
              <p class="block-sub">{{ account.mainUserName }}</p>
              <p v-if="account.mainMobile" class="block-mobile">{{ maskPhone(account.mainMobile) }}</p>
            </div>
            <div class="layout__header-account-popup-block">
              <p v-if="+account.nooType === 0" class="block-title">子账号信息</p>
              <p class="block-name">{{ account.memberName }}</p>
              <p class="block-sub active" @click="onNavToUserInfo">{{ account.userName }}</p>
              <p v-if="account.mobile" class="block-mobile">{{ maskPhone(account.mobile) }}</p>
            </div>
            <div class="layout__header-account-popup-button" @click="loginOut">
              {{ +account.nooType === 0 ? '退出当前子账号' : '退出当前主账号' }}
            </div>
          </div>
        </div>
      </template>
      <div class="layout__content">
        <el-breadcrumb
          v-if="$route.query.breadcrumb"
          class="layout__content-breadcrumb"
          separator-class="el-icon-arrow-right"
        >
          <el-breadcrumb-item
            v-for="(item, index) in breadcrumb"
            :key="index"
            :class="{ 'layout__content-breadcrumb-current': item.name === $route.name }"
            @click.native="clickBreadcrumb(item)"
            >{{ item.title }}</el-breadcrumb-item
          >
        </el-breadcrumb>
        <keep-alive :include="cacheList">
          <router-view
            v-if="visible"
            :key="$route.name + $route.fullPath"
            :class="{ noTitle: $route.meta.noTitle }"
            class="layout__content--page"
          />
        </keep-alive>
      </div>
      <updateVersion></updateVersion>
    </zczy-frame>
  </div>
</template>

<script>
import updateVersion from './components/updateVersion.vue';
import elButtonSelect from '@/components/el-button-select';
import layoutMixin from './mixins/layoutMixin';
import vipKefuJs from '@/assets/js/vipKefu';
import { mapMutations, mapActions } from 'vuex';
import { loginService } from '@/services/login';
import roleApi from '@/services/info/role';
import { getTempToken } from '@/services/ownerFreightloan/drawDeposit';
import { queryHaveOpen } from '@/services/ownerFreightloan/technicalServiceFee';
import { consignorService } from '@/services/consignor';
import { handleBadgeData, badgeMenus } from './mixins/common.js';
import defaultAvatar from '@/assets/images/ico_avatar_default.png';

export default {
  name: 'LayoutPage',
  components: { updateVersion, elButtonSelect },
  mixins: [layoutMixin],
  data() {
    return {
      defaultAvatar,
      activeMenu: '',
      channel: '',
      COOPERATION_NAME: '',
      XINJIANG_SULE: '',
      ZHONGMIAN_ZHIYUN: '',
      memberName: '',
      headUrl: '',
      hideShowFreightLoan: true,
      options: [
        { label: 1, value: '旧版' },
        { label: 2, value: '新版' }
      ],
      collectTooltip: {
        add: '点击收藏菜单',
        remove: '取消收藏'
      },
      // 是否有权限访问招投标 bidSwitchFlag  0否 1是
      bidSwitchFlag: '',
      jmsItemLink: 'https://owner-jms.zczy56.com/modules/mms/system/login.html',
      extraItemLink: 'http://extra-web.zczy56.com/modules/mms/system/login.html'
    };
  },
  computed: {
    hasSidebar() {
      return !this.$route.meta.hasSidebar;
    },

    activeHeaderId() {
      return this.$route.meta.headerId || '';
    },
    activeId() {
      return this.activeMenu || this.activeSubMenu;
    },
    activeMenuList() {
      return this.menuList.filter(
        (route) =>
          route.title !== '智运账本' &&
          route.title !== '智运账本部门专户' &&
          route.title !== '公共功能' &&
          !(route.title && route.title.indexOf('运费通') !== -1 && this.hideShowFreightLoan) &&
          route.title !== '统计报表' &&
          route.title !== '招投标' &&
          route.title !== '交易通钱包'
      );
    },
    menus() {
      const menus = [
        {
          id: 'myFortune',
          title: '我的智运',
          pathName: 'myFortune',
          documentTitle: '我的智运-个人中心',
          children: this.activeMenuList
        }
      ];
      if (this.$utils.checkPermission(['zyb:zybaccountbook'])) {
        menus.push({
          id: 'myPay',
          title: '智运账本',
          pathName: 'myPay',
          documentTitle: '我的智运-智运账本'
        });
      }
      if (this.$utils.checkPermission(['consig:departmentalAccountManagement'])) {
        menus.push({
          id: 'myPayDept',
          title: '智运账本-部门专户',
          pathName: 'myPayDept',
          documentTitle: '我的智运-智运账本-部门专户',
        });
      }
      if (this.$utils.checkPermission(['consig:jytqb'])) {
        menus.push({
          id: 'jiaoyitong',
          title: '交易通钱包',
          pathName: 'jiaoyitong',
          documentTitle: '我的智运-交易通钱包'
        });
      }
      menus.push(
        ...[
          {
            id: 'report',
            title: '统计报表',
            pathName: 'report',
            documentTitle: '统计报表'
          },
          {
            id: 'messageList',
            title: '消息公告',
            name: 'messageList',
            pathName: 'messageListNew',
            documentTitle: '消息公告',
            type: 'dropdown',
            children: [
              {
                id: 'messageList',
                title: '消息中心',
                name: 'messageList',
                pathName: 'messageListNew',
                documentTitle: '消息中心'
              },
              {
                id: 'announcementListNew',
                title: '我的公告',
                pathName: 'announcementListNew',
                documentTitle: '我的公告'
              }
            ]
          }
        ]
      );
      if (this.bidSwitchFlag == '1') {
        menus.push({
          id: 'index',
          title: '招标平台',
          pathName: 'index',
          documentTitle: '招标平台'
        });
      }
      if (this.$utils.checkPermission(['consig:creditCertificate:query'])) {
        menus.push({
          id: 'BlockChain',
          title: '区块链浏览器',
          pathName: 'BlockChain',
          documentTitle: '我的智运-区块链浏览器'
        });
      }
      menus.push({
        id: 'Contract',
        title: '合同管理系统',
        pathName: 'Contract',
        documentTitle: '我的智运-合同管理系统'
      });
      return menus;
    },
    badgeData() {
      const badgeData = handleBadgeData(this.bageObj);
      for (const key in badgeData) {
        if (!badgeMenus.includes(key)) {
          delete badgeData[key];
        }
      }
      return {
        ...badgeData,
        messageList: this.tipsCount || 0
      };
    },
    collects() {
      return this.collectionList.map((item) => ({
        ...item,
        title: item.name,
        id: item.menuId
      }));
    },
    currentVersion: {
      get() {
        return localStorage.getItem('version') || this.version;
      },
      set(val) {
        localStorage.setItem('version', val);
        this.SET_VERSION(val);
      }
    }
  },
  created() {
    // TODO: 待完全切换至宽屏，将下方样式移至css
    const floatDom = document.querySelector('.page-fixdiv');
    if (floatDom) {
      floatDom.style.top = '72px';
    }
    try {
      this.COOPERATION_NAME = COOPERATION_NAME;
      this.XINJIANG_SULE = XINJIANG_SULE;
      this.ZHONGMIAN_ZHIYUN = ZHONGMIAN_ZHIYUN;
    } catch (error) {}
    this.getMenus();
  },
  mounted() {
    const href = window.location.href;

    if (href.indexOf('pre-hz') !== -1) {
      this.oldServicePlace = 'http://pre.zczy-web.zczy.com/modules/mms/system/login.html';
      this.jmsItemLink = 'http://pre.zczy-franchiser-web.zczy.com/modules/mms/system/login.html';
      this.extraItemLink = 'http://pre.zczy-entry-web.zczy.com/modules/mms/system/login.html';
    } else if (
      href.indexOf('hz.zczy') !== -1 ||
      href.indexOf('jszczy56.com') !== -1 ||
      href.indexOf('zczyah.com') !== -1 ||
      href.indexOf('zczytj.com') !== -1 ||
      href.indexOf('longkou.zczy100.com') !== -1
    ) {
      this.oldServicePlace = 'https://www.zczy56.com/modules/mms/system/login.html';
    } else {
      this.oldServicePlace = 'http://sit.zczy-web.zczy.com/modules/mms/system/login.html';
      this.jmsItemLink = 'http://sit.zczy-franchiser-web.zczy.com/modules/mms/system/login.html';
      this.extraItemLink = 'http://sit.zczy-entry-web.zczy.com/modules/mms/system/login.html';
    }

    consignorService.getUserInfo({}).then((res) => {
      if (res) {
        this.bidSwitchFlag = res.bidSwitchFlag;
      }
    });

    this.headUrl = localStorage.getItem('headUrl');
    this.memberName = localStorage.getItem('memberName');
    this.channel = localStorage.getItem('channel');

    if (this.channel == 'zhongqi') {
      let liAppDom = document.querySelector('.li-app');
      if (liAppDom) {
        liAppDom.style.display = 'none';
      }
    }
  },
  beforeDestroy() {
    // TODO: 待完全切换至宽屏，移出下方样式内容
    const floatDom = document.querySelector('.page-fixdiv');
    if (floatDom) {
      floatDom.style.top = '30%';
    }
  },
  methods: {
    ...mapActions('log', ['getLeftMenuCornerMarker']),
    ...mapMutations('log', [
      'setMenuList',
      'setActiveSubMenu',
      'setPermissionLists',
      'setBageObj',
      'setCollectionList',
      'SET_MENULIST'
    ]),
    ...mapMutations('user', ['SET_VERSION']),
    // 手机号脱敏处理
    maskPhone(phone) {
      if (!phone) return '';
      const phoneStr = phone.toString();
      if (phoneStr.length < 7) return phoneStr;
      // 前3位 + 4个星号 + 后4位
      return phoneStr.substring(0, 3) + '****' + phoneStr.substring(phoneStr.length - 4);
    },
    isSpecificUrlPrefix() {
      const currentUrl = window.location.href;
      const specificPrefix = 'http://172.20.20.23:8879/';
      const ip192Prefix = 'http://192.168';
      return currentUrl.startsWith(specificPrefix) || currentUrl.startsWith(ip192Prefix);
    },
    async getMenus() {
      let vm = this;
      let menuList = [];
      menuList = vm.menuRecursion(this.primaryMenus);

      // // 获取工行贷状态,京东贷状态
      // Promise.all([findJddState(),findSapState()]).then(res => {
      //     if (res[0].code == 200 || res[1].code == 200) {
      //         const data = res[0]
      //         const data1 = res[1].data
      //         if ((data1.sapApplyFlag == 1 && data1.applySapState == 8) || (data.jdApplyFlag == 1 && data.applyJdState == 2)) {
      //             // 展示
      //             this.hideShowFreightLoan = false
      //             vm.setMenuList(menuList)
      //         } else {
      //             // // 不展示
      //             // menuList = menuList.filter(item => item.title != "货主运费贷")
      //             // this.setMenuListData(menuList);
      //         }

      // 	} else {

      // 	}
      // })
      queryHaveOpen({}, { errHandler: false }).then((res) => {
        // 展示
        this.hideShowFreightLoan = false;
        vm.setMenuList(menuList);
      });
      this.setMenuListData(menuList);
    },
    setMenuListData(menuList) {
      let vm = this;
      vm.setMenuList(menuList);
      let currentMenuId = null;
      currentMenuId = vm.getCurrentMenuId(menuList, vm.currentMenus.name);
      if (!currentMenuId) {
        currentMenuId = vm.currentMenus.id;
      }
      if (vm.currentMenus) {
        if (vm.currentMenus.name === 'primaryAccountNumber' && vm.currentMenus.name !== 'myFortune') {
          vm.$router.push({
            path: '/publicPage/primaryAccountNumber'
          });
          return;
        }
        if (vm.currentMenus.name === 'certificationUpgrade') {
          vm.$router.push({
            path: '/publicPage/certificationUpgrade',
            query: vm.currentMenus.query
          });
          return;
        }
        if (!currentMenuId) {
          vm.$router.push({
            path: Vue.$config.home
          });
          return;
        }
      }
      this.setActiveSubMenu(currentMenuId);
      this.activeMenu = currentMenuId;
      // 权限
      // let res = await roleApi.selectUserPermissionList({})
      // if (res.code == 200) {
      // 	let permissionLists = res.data.map(item => item.perm)
      // 	if (permissionLists.length > 0) {
      // 		//
      // 		localStorage.setItem('permissionLists', permissionLists)
      // 		this.setPermissionLists(permissionLists)
      // 	}
      // }
      this.getLeftMenuCornerMarker();
      // } catch {
      // 	this.$message.warning('获取菜单失败，请联系管理员')
      // }
    },
    // 根据路由名字查找菜单id
    getCurrentMenuId(list, name) {
      let id = null;
      list.forEach((it) => {
        if (id) {
          return;
        }
        if (it.name === name) {
          id = it.id;
        } else if (it.children && it.children.length) {
          id = this.getCurrentMenuId(it.children, name);
        }
      });
      return id;
    },
    menuRecursion(object) {
      let menuList = [];
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          let ele = object[key];
          // 历史遗留问题，accountManager、invoiceManagerList目录要单独处理
          if (ele.url === 'accountManager' || ele.url === 'invoiceManagerList') {
            ele = {
              ...ele,
              children: null
            };
          }
          // 因为统计下面的统计报表无法取消，其他系统有绑定该权限，所以在代码里面过滤掉此页面
          if (ele.url != 'waybillTatistics') {
            let newNode = {
              title: ele.name,
              icon: ele.icon,
              name: ele.url,
              id: ele.menuId
            };
            if (ele.children && Array.isArray(ele.children) && ele.children.length > 0) {
              newNode.children = this.menuRecursion(ele.children);
            }
            menuList.push(newNode);
          }
        }
      }
      return menuList;
    },
    onNavToUserInfo() {
      this.$router.push({
        name: 'userInfo'
      });
    },
    onClickLogo() {
      const menu = this.menuList.find((item) => item.name === 'myFortune');
      this.activeMenu = (menu && menu.id) || '';
      this.$router.push({ name: 'myFortune' });
    },
    onCollectClick(menu, type) {
      //操作类型 0-取消 1-收藏
      roleApi
        .collectMenu({
          operateType: type ? 1 : 0,
          menuId: menu.id
        })
        .then(() => {
          this.$store.dispatch('log/getCollectionList');
        });
    },
    removeElementById(elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        var parent = element.parentNode;
        if (parent) {
          parent.removeChild(element);
        }
      }
    },
    onHeaderMenuClick(item) {
      if (item.pathName === 'myPay') {
        window.location.href = '/pay/index.html';
        return;
      }
       if (item.pathName === 'myPayDept') {
        window.location.href = '/pay/index.html#/departmentAccountIndex';
        return ;
      }

      if (item.pathName === 'jiaoyitong') {
        window.location.href = '/pay/index.html#/jiaoyitongIndex';
        return;
      }
      if (item.pathName === 'report') {
        window.location.href = '/bid/report.html';
        return;
      }
      if (item.pathName === 'index') {
        window.location.href = '/bid/index.html';
        return;
      }

      if (item.pathName === 'Contract') {
        getTempToken({ tenantCode: 'ZCZY', systemFlag: 34 }).then((res2) => {
          if (res2.code == '200') {
            let url = `http://sit.scm.zczy.com/#/emptyPage?jumpParams=personalInfo`;
            if (location.href.indexOf('hz.zczy56.com') > -1 || localStorage.getItem('officially') == '1') {
              url = `https://scm.zczy56.com/ams/customer/#/emptyPage?jumpParams=personalInfo`;
            }
            window.open(url + '&token=' + res2.data.token, '_blank');
          }
        });
        return;
      }
      this.$router.push({
        name: item.pathName
      });
      document.title = item.documentTitle;
    },
    onMenuClick(currentMenu, type) {
      let currentMenuId = currentMenu.menuId || currentMenu.id;
      if (this.activeMenu === currentMenuId) {
        this.reload();
      }
      this.activeMenu = currentMenuId;
      this.setActiveSubMenu(currentMenuId);
      if (
        this.account &&
        this.account.userType === 6 &&
        currentMenu.url !== '/publicPage/myFortune' &&
        currentMenu.name !== 'myFortune'
      ) {
        this.$router.push('/publicPage/primaryAccountNumber');
      } else {
        if (currentMenu.url) {
          this.$router.push(currentMenu.url);
        } else {
          this.$router.push({
            name: currentMenu.name
          });
        }
      }
    },
    loginOut() {
      // 处理银轮定制
      let obj = { name: 'Login' };
      let isOwnerCS = localStorage.getItem('isOwnerCS');
      this.removeElementById('myIframe');
      if (this.channel && this.channel != 'null' && this.channel != 'undefined') {
        obj.query = {
          channel: this.channel
        };
      } else {
        this.channel = '';
        localStorage.setItem('channel', '');
      }
      // this.$router.push({ name: 'Login' })
      loginService
        .logout({ sessionId: localStorage.getItem('tokenId') })
        .then((res) => {
          if (res && res.code === '200') {
          }
          vipKefuJs.removeVipKefuData();
          this.$store.dispatch('resetState');
          localStorage.clear();
          localStorage.setItem('channel', this.channel);
          localStorage.setItem('isOwnerCS', isOwnerCS);
          this.$router.push(obj);
          this.SET_MENULIST(null);
        })
        .catch((err) => {
          localStorage.clear();
          localStorage.setItem('channel', this.channel);
          localStorage.setItem('isOwnerCS', isOwnerCS);
          this.$router.push(obj);
          this.SET_MENULIST(null);
        });
    },
    async handleLink() {
      // 获取临时token
      const params = {
        tenantCode: 'ZCZY',
        systemFlag: 2,
        mTmsFlag: 1
      };
      getTempToken(params).then((res2) => {
        if (res2.code == '200') {
          let url = `http://172.20.20.23:9190/#/dashboard`;
          if (location.href.indexOf('hz.zczy56.com') > -1 || localStorage.getItem('officially') == '1') {
            url = `https://scm.zczy56.com/mtms/consignor/#/dashboard`;
          }
          if (res2.data.token) {
            window.open(url + '?token=' + res2.data.token, '_blank');
          } else if (res2.data.jumpType == 1) {
            url = window.location.origin + '/consignor.html#/cooperativeConsultation';
            window.open(url, '_blank');
          } else if (res2.data.jumpEnable == 0) {
            this.$message({
              message: res2.data.resultMsg,
              type: 'warning'
            });
          }
        }
      });
    },
    onChooseRole(command) {
      switch (command) {
        case 'ship':
          window.location.href = 'https://shipnew.zczy56.com';
          break;
        case 'link':
          this.handleLink();
          break;
        case 'jms':
          window.location.href = this.jmsItemLink;
          break;
        case 'extra':
          window.location.href = this.extraItemLink;
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-content {
  background-color: #fff;
}

.layout {
  background-color: #f5f6f7;
  .zczy-frame {
    min-width: 1200px;
    ::v-deep .zczy-header__menu--dropdown {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        right: -16px;
        top: 1px;
        bottom: 0;
        margin: auto;
        width: 1px;
        height: 12px;
        background: rgba(255, 255, 255, 0.4);
      }
      .el-badge__content {
        background: #fd4242;
      }
    }
    .side-bar__popupMenu--item {
      .svg-icon {
        margin-right: 6px;
      }
    }
  }

  &__logo {
    display: inline-flex;
    align-items: center;

    &-icon {
      width: 182px !important;
      height: 26px !important;
      margin-right: 9px;
    }

    &-tag {
      background: linear-gradient(90deg, #0a8bff 0%, #2f9ff8 100%);
      border-radius: 3px;
      color: #fff;
      padding: 2px 5px;
      font-size: 12px;
    }
  }

  &__header {
    &-operate {
      display: flex;
      align-items: center;
      justify-content: center;

      &-item {
        display: inline-flex;
        align-items: center;
        padding: 0 16px;
        border-right: 1px solid rgba(255, 255, 255, 0.4);
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 12px;
        height: 12px;
        cursor: pointer;

        ::v-deep .svg-icon {
          margin-right: 6px;
        }

        ::v-deep .el-dropdown {
          color: #fff;
          font-weight: 400;
          font-size: 12px;
          line-height: 12px;
        }
      }

      &-phone span,
      &-desktop span {
        display: initial;
      }
    }
    &-account {
      position: relative;
      display: inline-flex;
      align-items: center;
      margin-left: 16px;
      height: 100%;
      &-ico {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        cursor: pointer;
      }
      &-text {
        font-weight: 400;
        font-size: 12px;
        color: #fff;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-left: 8px;
        a {
          cursor: pointer;
          color: #fff;
        }
      }
      &-name {
        max-width: 10em;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-tag {
        margin-left: 4px;
        width: 14px !important;
        height: 14px !important;
      }
      &-popup {
        display: none;
        position: absolute;
        top: 100%;
        right: 0;
        background: rgba(209, 225, 255, 1);
        box-shadow:
          0px 6px 16px 0px rgba(0, 0, 0, 0.08),
          0px 3px 6px -4px rgba(0, 0, 0, 0.12),
          0px 9px 28px 8px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        width: 254px;
        padding-bottom: 12px;
        z-index: 99999;
        .icon-account-0 {
          background: url('../../assets/images/ico_account_sub.png') no-repeat 0 0;
          background-size: 100% 100%;
          width: 20px;
          height: 20px;
        }
        .icon-account-1 {
          background: url('../../assets/images/ico_account_main.png') no-repeat 0 0;
          background-size: 100% 100%;
          width: 20px;
          height: 20px;
        }
        &-arr {
          position: absolute;
          top: -4px;
          right: 40%;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-bottom: 4px solid rgba(209, 225, 255, 0.8);
        }
        &-header {
          display: flex;
          align-items: center;
          background: url('../../assets/images/ico_account_doc.png') no-repeat 100% 100%;
          background-size: 88px 30px;
          height: 54px;
          &-info {
            background: linear-gradient(122deg, rgba(193, 226, 255, 0) 0%, rgba(107, 153, 255, 0.3) 100%);
            border-radius: 4px;
            display: flex;
            align-items: center;
            height: 22px;
            padding: 0 8px 0 12px;
            &-title {
              font-weight: 500;
              font-size: 14px;
              color: #2767dd;
              line-height: 22px;
              margin-left: 4px;
            }
          }
        }
        &-block {
          background: #fff;
          box-shadow: 0px 0px 12px 0px rgba(148, 138, 255, 0.2);
          border-radius: 4px;
          margin: 0 12px 6px;
          padding: 12px;
          .block-title {
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 17px;
            margin-bottom: 8px;
          }
          .block-name {
            display: -webkit-box;
            font-weight: 600;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 10px;
          }
          .block-sub {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 10px;
            &.active {
              color: #2767dd;
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
            }
          }
          .block-mobile {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
          }
        }
        &-button {
          background: #fff;
          box-shadow: 0px 0px 12px 0px rgba(148, 138, 255, 0.2);
          border-radius: 4px;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          text-align: center;
          padding: 6px 0;
          margin: 0 12px;
          cursor: pointer;
        }
      }
      &:hover {
        .layout__header-account-popup {
          display: block;
        }
      }
    }
  }

  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    &-breadcrumb {
      background: #fff;
      padding: 16px;
      margin-bottom: 0px;
      margin-right: 75px;
      border-radius: 4px;
      &-current {
        .el-breadcrumb__inner {
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }
      }
    }

    &--page {
      padding: 16px 76px 16px 16px;
      height: 100%;
      overflow-y: auto;
    }
  }
  @media screen and (max-width: 1300px) {
    .layout__header-operate-phone span,
    .layout__header-operate-desktop span {
      display: none;
    }
    ::v-deep .zczy-header__user-text {
      display: inline-flex;
    }
  }
}
</style>
<style lang="scss">
html,
body {
  min-width: 1200px;
}
.popper_white {
  background-color: #fff !important;
  border: 0 !important;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
}
.header-link-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px !important;
  height: 48px !important;
  min-width: 132px;
}
.icon-item {
  width: 20px !important;
  height: 20px !important;
  margin-right: 0 !important;
}
.role-dp-item {
  color: #333;
  font-size: 14px;
}
</style>
